import { Phone } from "lucide-react";
import { scrollToSection } from "@/App";

const links = [
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "Work", href: "#gallery", testId: "nav-link-gallery" },
  { label: "Why Us", href: "#why-us", testId: "nav-link-why-us" },
];

export default function Nav() {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToSection("#top")}
          className="font-display text-xl md:text-2xl font-extrabold tracking-widest uppercase text-white hover:text-timber transition-colors duration-300"
        >
          A E <span className="text-timber">Carpentry</span>
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={l.testId}
              onClick={() => scrollToSection(l.href)}
              className="text-sm uppercase tracking-[0.2em] text-neutral-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-phone-link"
            href="tel:0408166415"
            className="flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-neutral-300 hover:text-timber transition-colors duration-300"
          >
            <Phone size={14} /> 0408 166 415
          </a>
          <button
            data-testid="nav-get-quote-button"
            onClick={() => scrollToSection("#quote")}
            className="bg-timber hover:bg-timber-hover text-obsidian font-display font-bold uppercase tracking-widest text-sm px-6 py-2.5 transition-colors duration-300"
          >
            Get Quote
          </button>
        </nav>
        <a
          data-testid="nav-phone-link-mobile"
          href="tel:0408166415"
          className="md:hidden flex items-center gap-2 text-timber"
          aria-label="Call A E Carpentry"
        >
          <Phone size={20} />
        </a>
      </div>
    </header>
  );
}
